import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import ChartHeader from "./ChartHeader";

function ChartHours({ title, subtitle, data, orderNumber = "", dateRange = "" }) {
    // Domyślne dane - w rzeczywistej aplikacji będą przekazane jako props
    const defaultData = [
        { date: 'n/a', value: "n/a" }
    ];

    const inputData = data || defaultData;

    // Funkcja do formatowania daty (opcjonalnie)
    const formatDate = (dateString) => {
        // Możesz dostosować formatowanie daty według potrzeb
        return dateString;
    };

    // Przygotowanie danych dla wykresu - filtrujemy tylko wpisy z wartością > 0
    const filteredData = inputData.filter(item => item.value > 0);

    const chartData = filteredData.map(item => ({
        name: formatDate(item.date),
        value: item.value,
        originalDate: item.date
    }));

    // Obliczenie statystyk
    const totalHours = filteredData.reduce((sum, item) => sum + item.value, 0);
    const activeCategories = filteredData.length;
    const peakHours = chartData.length > 0 ? Math.max(...chartData.map(d => d.value)) : 0;

    // Niestandardowa tooltip
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const data = payload[0];
            return (
                <div style={{
                    backgroundColor: 'white',
                    padding: '8px 12px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '13px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <p style={{ margin: 0, fontWeight: '600' }}>{label}</p>
                    <p style={{ margin: 0, color: '#666' }}>{`Hours: ${data.value}`}</p>
                </div>
            );
        }
        return null;
    };

    // Style oparte na oryginalnym ContactContainer
    const styles = {
        container: {
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            padding: '24px',
            margin: '16px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid rgba(0, 0, 0, 0.06)'
        },
        header: {
            marginBottom: '24px'
        },
        statsContainer: {
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginBottom: '24px',
            padding: '0 20px'
        },
        statItem: {
            textAlign: 'center'
        },
        statNumber: {
            fontSize: '20px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        statLabel: {
            fontSize: '13px',
            color: 'rgb(123, 128, 154)',
            margin: '4px 0 0 0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        chartContainer: {
            backgroundColor: 'rgb(248, 249, 250)',
            borderRadius: '6px',
            padding: '24px',
            minHeight: '350px',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '28px'
        },
        legendContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '16px'
        },
        legendItem: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '13px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        legendColor: {
            width: '12px',
            height: '12px',
            backgroundColor: 'blue',
            marginRight: '6px',
            borderRadius: '2px'
        },
        legendText: {
            color: 'rgb(52, 71, 103)',
            fontWeight: '500'
        }
    };

    return (
        <div style={styles.container}>
            <ChartHeader
                title={title}
                subtitle={subtitle}
                orderName={orderNumber}
                dateRange={dateRange}
            />

            <div style={styles.chartContainer}>
                <div style={styles.statsContainer}>
                    <div style={styles.statItem}>
                        <p style={styles.statNumber}>{activeCategories}</p>
                        <p style={styles.statLabel}>Analysis days</p>
                    </div>
                    <div style={styles.statItem}>
                        <p style={styles.statNumber}>{totalHours}</p>
                        <p style={styles.statLabel}>Total Hours</p>
                    </div>
                    <div style={styles.statItem}>
                        <p style={styles.statNumber}>{peakHours}</p>
                        <p style={styles.statLabel}>Peak Hours</p>
                    </div>
                </div>
                <ResponsiveContainer width="100%" height={280}>
                    <BarChart
                        data={chartData}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 60
                        }}
                    >
                        <XAxis
                            dataKey="name"
                            tick={{
                                fontSize: 12,
                                fill: 'rgb(123, 128, 154)',
                                fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
                            }}
                            axisLine={false}
                            tickLine={false}
                            angle={-45}
                            textAnchor="end"
                            height={80}
                        />
                        <YAxis
                            tick={{
                                fontSize: 12,
                                fill: 'rgb(123, 128, 154)',
                                fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
                            }}
                            axisLine={false}
                            tickLine={false}
                            label={{
                                value: 'Hours count',
                                angle: -90,
                                position: 'insideLeft',
                                style: {
                                    textAnchor: 'middle',
                                    fontSize: '16px',
                                    fill: 'rgb(123, 128, 154)',
                                    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
                                }
                            }}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="value"
                            fill="blue"
                            radius={[4, 4, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>

                <div style={styles.legendContainer}>
                    <div style={styles.legendItem}>
                        <div style={styles.legendColor}></div>
                        <span style={styles.legendText}>Hours</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChartHours;